export enum CommentSortingOption {
  RecentActivityOption = 'recentActivityAt',
  DateCreatedOption = 'createdAt',
}
